export const SET_RETAILERS = 'retailers/set-retailer-items';
